export default __webpack_public_path__ + "static/media/fullDashboardLogo.d3f44af1.png";